import { useIntl } from 'react-intl';
import React, { useMemo } from 'react';
import { messages } from '../messages';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { getCopyNumberType, getCopyNumberValue } from '../observationUtils';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { getTestProps } from '../../../../../../util/testProps';

export const copyNumberVariantTestIds = {
  gene: 'copyNumberVariant-gene',
  value: 'copyNumberVariant-value',
  type: 'copyNumberVariant-type',
};

export interface CopyNumberVariantProps {
  gene: string;
  observation: fhir.Observation;
}

export const CopyNumberVariant = (props: CopyNumberVariantProps) => {
  const { formatMessage } = useIntl();
  const { gene, observation } = props;

  const copyNumberValue = useMemo(
    () => getCopyNumberValue(observation),
    [observation],
  );
  const copyNumberType = useMemo(
    () => getCopyNumberType(observation),
    [observation],
  );

  return (
    <>
      {gene && (
        <Tooltip title={formatMessage(messages.targetGene)}>
          <Text size="subbody" {...getTestProps(copyNumberVariantTestIds.gene)}>
            {gene}
          </Text>
        </Tooltip>
      )}
      {copyNumberType && (
        <Tooltip title={formatMessage(messages.copyNumberType)}>
          <Text size="subbody" {...getTestProps(copyNumberVariantTestIds.type)}>
            {copyNumberType}
          </Text>
        </Tooltip>
      )}
      {copyNumberValue && (
        <Tooltip title={formatMessage(messages.copyNumberValue)}>
          <Text
            size="subbody"
            {...getTestProps(copyNumberVariantTestIds.value)}
          >
            {`CN=${copyNumberValue}`}
          </Text>
        </Tooltip>
      )}
    </>
  );
};
